import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { styles } from './styles';

export const PlainLoader = () => {
  const classes = styles();
  return <CircularProgress className={classes.loader} />;
};
